import { getIsNullish } from '../getIsNullish/getIsNullish';
import { isEmptyArray } from '../isEmptyArray/isEmptyArray';
import { isEmptyObject } from '../isEmptyObject/isEmptyObject';

export const isEmptyValue = (value: any): boolean =>
  getIsNullish(value) || value === '' || isEmptyArray(value) || isEmptyObject(value);
